import _objectSpread from "/home/runner/work/polyglot-frontend/polyglot-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import produce from 'immer';
import * as actionTypes from './actionTypes';
var initialState = {
  locale: undefined,
  phrases: undefined,
  phrasesLoading: false,
  phrasesLoaded: false,
  phrasesError: undefined
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return produce(state, function (draft) {
    switch (action.type) {
      case actionTypes.SET_LOCALE:
        draft.locale = action.payload.locale;
        break;

      case actionTypes.FETCH_PHRASES:
        draft.phrasesLoading = true;
        break;

      case actionTypes.FETCH_PHRASES_SUCCESS:
        draft.phrasesLoading = false;
        draft.phrasesLoaded = true;
        draft.phrasesError = undefined;
        draft.phrases = action.payload.phrases;
        break;

      case actionTypes.FETCH_PHRASES_FAIL:
        draft.phrasesLoading = false;
        draft.phrasesLoaded = false;
        draft.phrasesError = {
          status: action && action.error && action.error.status || 'Error fetching phrases'
        };
        break;

      case actionTypes.SET_DEFAULT_PHRASES:
        draft.phrases = _objectSpread({}, draft.phrases, {
          default: action && action.payload && action.payload.defaultPhrases || undefined
        });
        draft.phrasesLoaded = true;
        break;

      default:
        break;
    }
  });
};

export default reducer;